import React, { createContext, useContext, useEffect, useState } from "react";

// Create the Authentication Context
const AuthenticationContext = createContext();

export const AuthenticationProvider = ({ children }) => {
  const data = "Hii Auth";

  // State to hold account and contact IDs
  const [sessionAccountId, setSessionAccountId] = useState(null);
  const [sessionCustomerId, setSessionCustomerId] = useState(null);
  const [sessionOpportunityId, setSessionOpportunityId] = useState(
    sessionStorage.getItem("opportunityId")
  );

  // State to manage screen size
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Fetch accountId and contactId from cache on component mount
  useEffect(() => {
    const fetchCacheData = async () => {
      try {
        // Open the cache named 'user-data-cache'
        const cache = await caches.open("user-data-cache");
        // Try to find the '/user-data' entry in the cache
        const response = await cache.match("/user-data");
        if (response) {
          // If found, parse the cached data
          const cachedData = await response.json();

          // Check if both accountId and contactId exist before updating state
          const accountId = cachedData.accountId || null;
          const contactId = cachedData.contactId || null;
          console.log("hit"+contactId);

          if (accountId || contactId) {
            setSessionAccountId(accountId);
            setSessionCustomerId(contactId);
          } else {
            console.log("No accountId or contactId found in cache.");
          }
        } else {
          console.log("No data found in cache.");
        }
      } catch (error) {
        console.error("Error fetching data from cache:", error);
      }
    };

    // Call the function to fetch cached data
    fetchCacheData();
  }, []); // Runs only once when the component mounts

  // Effect to handle screen resizing
  useEffect(() => {
    const handleResize = () => {
      // Update the screenSize state when the window is resized
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add the resize event listener
    window.addEventListener("resize", handleResize);
    // Cleanup: remove the resize event listener when the component unmounts
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Provide the context values to children components
  return (
    <AuthenticationContext.Provider
      value={{
        data,
        screenSize,
        sessionAccountId,
        sessionCustomerId,
        sessionOpportunityId,
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};

// Custom hook to use Authentication Context
export const useAuthenticationContext = () => {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error(
      "useAuthenticationContext must be used within an AuthenticationProvider"
    );
  }
  return context;
};
